// Rotas das páginas da Campanha Inteligente (antes eram popups em Campanhas).
export const ROTA_CAMPANHAS = "/admin/impulsione/campanhas";
export const ROTA_CONFIG = "/admin/impulsione/campanhas/campanha-inteligente";
export const ROTA_HUB_RELATORIOS = "/admin/impulsione/relatorio-ofertas/campanhas";
export const ROTA_RELATORIO = "/admin/impulsione/relatorio-ofertas/campanhas/campanha-inteligente";
